import { createSupabaseAdminClient } from "@/lib/supabase/admin"
import type { Comment } from "@/types/comment"

function mapCommentRow(row: {
  id: string
  recipe_id: string
  parent_id: string | null
  author_name: string
  text: string
  status: "pending" | "approved" | "rejected"
  created_at: string
}): Comment {
  return {
    id: row.id,
    recipeId: row.recipe_id,
    parentId: row.parent_id,
    authorName: row.author_name,
    text: row.text,
    status: row.status,
    createdAt: row.created_at,
  }
}

export async function getApprovedCommentsByRecipeId(
  recipeId: string,
): Promise<Comment[]> {
  const supabase = createSupabaseAdminClient()

  const { data, error } = await supabase
    .from("recipe_comments")
    .select("id, recipe_id, parent_id, author_name, text, status, created_at")
    .eq("recipe_id", recipeId)
    .eq("status", "approved")
    .order("created_at", { ascending: false })

  if (error || !data) {
    console.error("Failed to load comments from Supabase:", error?.message)
    return []
  }

  return data.map(mapCommentRow)
}

export async function getCommentCountByRecipeId(
  recipeId: string,
): Promise<number> {
  const comments = await getApprovedCommentsByRecipeId(recipeId)
  return comments.length
}

export function groupCommentsByParent(commentsList: Comment[]) {
  const rootComments = commentsList.filter((comment) => !comment.parentId)
  const replies = commentsList.filter((comment) => comment.parentId)

  return rootComments.map((root) => ({
    root,
    replies: replies.filter((reply) => reply.parentId === root.id),
  }))
}
